export default "__VITE_PUBLIC_ASSET__1db1ccfe__"